export default function PercentToHex(value)
{
	const hex = (Math.round(value * 2.55)).toString(16); // percent to hex
	return hex.length === 1 ? '0' + hex : hex;
}
